import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRespuesta, ApiRespuestaPaginada } from '@app/models/ApiRespuesta.interface';

import { catchError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { handleError } from '../tools/handle-error';
import { Conductor } from '@app/models/conductor';
import { NivelMD } from '@app/models/nivel-md';
import { TipoLicConductor } from '@app/models/tipo-lic-conductor';

@Injectable({
    providedIn: 'root'
})
export class ConductorService {
    private url = environment.url + 'conductor';
    private readonly http = inject(HttpClient);

    initForm() {
        const dir = this.url + '/initForm';
        return this.http.get<ApiRespuesta<{ nivel: NivelMD[]; tipoLicencia: TipoLicConductor[]; tipoConducir: TipoLicConductor[] }>>(dir).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    insert(conductor: Partial<Conductor>) {
        return this.http.post<ApiRespuesta<Conductor>>(this.url, conductor).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    getOne(id_usuario: string) {
        const direction = this.url + `/${id_usuario}`;
        return this.http.get<ApiRespuesta<Conductor>>(direction).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    getAll(params?: HttpParams) {
        const url = `${this.url}/get/all`;
        return this.http.get<ApiRespuestaPaginada<Conductor>>(url, { params }).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    update(conductor: Partial<Conductor>) {
        const url = `${this.url}/${conductor.id}`;
        return this.http.put<ApiRespuesta<Conductor>>(url, conductor).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    toggleActivo(id: string) {
        const url = `${this.url}/toggle/activo/${id}`;
        return this.http.post<ApiRespuesta<Conductor>>(url, null).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    // Ensure a gv_conductor exists for the given usuario id; if not, create it and return the conductor entity
    syncFromUsuario(id_usuario: string) {
        const url = `${this.url}/sync-from-usuario`;
        return this.http.post<ApiRespuesta<Conductor>>(url, { id_usuario }).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    createDefensiveCredential(id_usuario: string) {
        const url = `${this.url}/${id_usuario}/credencial-defensiva`;
        return this.http.post<ApiRespuesta<any>>(url, null).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }
}
